var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('the-game',{attrs:{"player-board":_vm.playerBoard,"computer-board":_vm.computerBoard,"game-flow":_vm.gameFlow,"player":_vm.player,"computer":_vm.computer},on:{"resetGame":_vm.resetGame}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }